<template>
<b-container
  class="p-2 p-md-5 bg-white"
  fluid
  >
  <b-row>
    <b-col class="text-center py-5">
      <slot name="icon">
	<b-img
	  :src="require('../assets/trinity_secure.png')"
	  class="my-5"
	  style="width: 200px;"
	  />
      </slot>
      <h1>What is inside a TrinPod<sup>&trade;</sup>?</h1>
    </b-col>
  </b-row>
  <b-container
    class="my-5"
    fluid
    >
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/webid_logo.png')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>WebID stores true, verified identities for users in order to give them an even better and extremely secure user experience.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/solid_logo_tr.png')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>The Web - Take 3: Solid is a technology, like the Web, but a new level of standard that gives you the user the freedom to move your data between pods and have different apps access it.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/trinity.png')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>Trinity is Graphmetrix Conceptual Computing AI</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img :src="require('../assets/rdf-icon-neon-blue.png')"
		 class="table-icon"
		 />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>A Semantic Triple is the atomic data entity in the Resource Description Framework data model. Three entities codifies a statement about semantic data; subject-predicate-object. 
	  This enables knowledge to be represented in a machine-readable way.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img :src="require('../assets/event_icon.png')"
		 class="table-icon"
		 />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>Event</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/network-icon-neon-blue.png')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>Ontologies encompasses a representation, formal naming and definition of the categories, properties and relations between the concepts, data and entities that substantiate one, many or all domains of discourse.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img :src="require('../assets/one-world-illustration.png')"
		 class="table-icon"
		 />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"class="py-3 border border-secondary border-bottom-0"
	>
	<span>Each TrinPod<sup>&trade;</sup> creates a One-World Model containing all information about an entity.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/graph-icon-neon-blue-600.png')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>Structured Linked data which is interlinked with other data so it becomes useful through semantic queries.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img :src="require('../assets/graph-icon-neon-blue-600.png')"
		 class="table-icon"
		 />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>A massively scalable graph database that uses graph structures for semantic queries with nodes, edges, and properties to represent and store data.</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/aws_logo.jpg')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary border-bottom-0"
	>
	<span>Cloud Storage on AWS<br>A reliable, scalable, and secure place for your data</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="3"
	sm="2"
	offset-sm="1"
	lg="1"
	offset-lg="2"
	class="d-flex"
	>
	<div class="m-auto p-2 p-lg-0 p-xl-2">
	  <b-img
	    :src="require('../assets/aws_logo.jpg')"
	    class="table-icon"
	    />
	</div>
      </b-col>
      <b-col
	cols="9"
	sm="8"
	xl="6"
	class="py-3 border border-secondary"
	>
	<span>Computational HW om AWS</span>
      </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
    name: "WhatsInsideTrinPod"
}
</script>

<style>
.table-icon {
    max-width: 80px;
    width: 100%;
    height: auto;
}
</style>
